import axios from 'axios'

export const getApplicationTokenAPI = () =>
  axios({
    url: `${process.env.REACT_APP_A2A_URL}/session/token?_format=json`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  })

export const renewApplicationTokenAPI = () =>
  axios({
    url: `${process.env.REACT_APP_A2A_URL}/jwt/token?_format=json`,
    headers: { 'Content-Type': 'application/json' },
  })

export const getStatusLoginAPI = (token) =>
  axios({
    url: `${process.env.REACT_APP_A2A_URL}/user/login_status?_format=json`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
